const okimono= new function(){
    const me = this;
    const config = { attributes: false, childList: true, subtree: false };
    var filter=null;
    
    me.init=()=>{
        console.log("init okimono");
        document.querySelectorAll(`variant-picker input[type="radio"]:checked`).forEach((el)=>{
            el.checked=false;
            el.dataset.currentChecked=false;
        });
        const forceDrawer = localStorage.getItem("force-drawer");
        console.log(`forceDrawer =${forceDrawer}`,document.querySelector("#header-component"));
        if(forceDrawer==="1") {
            console.log("forcing drawer");
            document.querySelector("#header-component").dataset.menuStyle="drawer";
            console.log(document.querySelector("#header-component").dataset.menuStyle);
        }
        document.querySelectorAll('a[href="/en/pages/niet-kreunen-maar-steunen"],a[href="/en/pages/niet-kreunen-maar-steunen"],.de a[href="/pages/niet-kreunen-maar-steunen"],.de a[href="/pages/niet-kreunen-maar-steunen"]').forEach((a)=>a.parentNode.style.display="none");
    }
    me.initReady=()=>{
        me.checkStampedReview();
        me.addKlaviyobackinstocktrigger();
        const productForm=document.querySelector(".product-information__grid product-form-component");
         const variants = document.querySelectorAll(".product-information__grid variant-picker input:not(.swatchInputBundle)");
        if(productForm && variants.length>1) {
            productForm.querySelector('input[ref="variantId"]').value="";
        }
   
    }

    me.observeVarianPicker=(mutationsList, observer)=>{
        console.log("observe");
         for(const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                const target=mutation.target;
                console.log(`target is ${target.tagName}`)

            }
        }
    }

    me.filtersUpdateForm=(form)=>{
        console.log("filter form");
        const allChecked =form.querySelectorAll('.facets__filters-wrapper input:not([name="filter.v.availability"]):checked');
        console.log(allChecked.length===1);
        if(allChecked.length===1){
            form.querySelector('.facets__filters-wrapper  input[name="filter.v.availability"]').checked=true;
        }

    }
/* REVIEW PLACEHOLDER STUFF 
    show Stamped info
    gekopieerd van de orginele template, eventueel nog aanpassen
*/
    me.addProdcutScore=(badge)=>{
        
        console.log("add stars")
        const infolinks =document.querySelector(".infolinks");
        if(!infolinks) return;
        if(infolinks.querySelector(".rating")) return;
        const rating=badge.querySelector(".stamped-summary-text-1");
        const link=document.createElement("a");
        link.href="#stamped-main-widget";    
        const p=document.createElement("p");
        p.classList.add("mb5","fl","rating");
        const strongrating=document.createElement("strong");
        strongrating.textContent=rating.dataset.rating;
        p.appendChild(strongrating);
        const stars=badge.querySelectorAll(".stamped-summary-starrating i");
        stars.forEach(star=>{
            p.appendChild(star.cloneNode());
        })
        const summaryText=document.createElement("b");
        summaryText.textContent=badge.querySelector(".stamped-summary-text").textContent;
        
        p.appendChild(summaryText);
        
        link.appendChild(p);
        infolinks.appendChild(link);
        if(infolinks.querySelector(".review-placeholder")) infolinks.querySelector(".review-placeholder").remove();
    }

    me.checkStampedReviewObserved=(mutationsList, observer)=> {
        for(const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                const stampedReview=document.querySelector("#stamped-main-widget");
                if(stampedReview.childElementCount>0){
                    const badge=stampedReview.querySelector(".stamped-container");
                    if(badge){
                        me.addProdcutScore(badge);
                        me.stop(observer)
                    }
                }    
            }
        }
    }

    me.checkStampedReview=()=>{
        const stampedReview=document.querySelector("#stamped-main-widget");
        if(stampedReview){
            if(stampedReview.childElementCount===0){
                me.addObserver(stampedReview,me.checkStampedReviewObserved,config)
            }else{
                const badge=stampedReview.querySelector(".stamped-container");
                if(badge){
                    me.addProdcutScore(badge);
                }else{
                    me.addObserver(stampedReview,me.checkStampedReviewObserved,config);  
                }
            }
        }
        const stampedReviewsWidget=document.querySelector("footer #stamped-reviews-widget");
        if(stampedReviewsWidget && stampedReviewsWidget.childElementCount>0){
            console.log('check stampedReviewsWidget');
        } else{
            console.log('no stampedReviewsWidget');
            me.addObserver(stampedReviewsWidget,me.stampedReviewsWidgetCheck,config)
        }  
    }

    me.stampedReviewsWidgetCheck=(mutationsList, observer)=> {
        for(const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                const stampedReview=document.querySelector("footer #stamped-reviews-widget");
                if(stampedReview.childElementCount>0){
                    if(me.addClonedReviewWidget(stampedReview)===true){
                        me.stop(observer)
                    }
                }    
            }
        }  
    }

    me.addClonedReviewWidget=(stampedReview)=>{
        const badge=stampedReview.querySelector("#stamped-badge-2");
        if(badge){
            const cloneBadge=badge.parentNode.parentNode.cloneNode(true);
            cloneBadge.classList.add(`cloned_${badge.id}`);
            const placeHolders=document.querySelectorAll('.review-placeholder');
            placeHolders.forEach((placeHolder)=>{
                if(placeHolder.childElementCount===0) {
                    placeHolder.appendChild(cloneBadge);
                }
            });
            return true
        }
        return false;
    }
    me.addKlaviyobackinstocktrigger=()=>{
        const toAddTrigger=document.querySelectorAll('.variant-options__wrap');
        toAddTrigger.forEach((el)=>{
            el.addEventListener('click',(event)=>{
                const element = event.currentTarget;
                if(element.querySelector('input[data-option-available="false"]')){        
                    const klaviyoBtn=document.querySelector("add-to-cart-component .button.add-to-cart-button+a.klaviyo-bis-trigger");
                    klaviyoBtn.click();
                }
            })
        });
        const addToCart=document.querySelector("add-to-cart-component");
        if(addToCart){
            addToCart.addEventListener('click',(event)=>{
                const element = event.currentTarget;
                const klaviyoBtn=document.querySelector("add-to-cart-component .button.add-to-cart-button+a.klaviyo-bis-trigger");
                if(element.querySelector(".button.add-to-cart-button:disabled")){  
                    klaviyoBtn.click();
                }
            });
        }
    }

  me.addToCart=function(form,overrideVariantId,overrideQuantity){
  
}
    /* ----------------- */
    me.stop=(observer)=>{observer.disconnect();};
me.addObserver=(target,callback)=>{
    console.log(`observe ${target.tagName}`);
    const observer = new MutationObserver(callback);
    observer.observe(target, config);

};
me.addObserver=(target,callback, myconfig)=>{
  	
    console.log(`observe ${target.tagName}`);
    const observer = new MutationObserver(callback);
    observer.observe(target, myconfig||config);

};
}
okimono.init();
document.addEventListener('DOMContentLoaded', okimono.initReady, false); 